import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import { toast } from 'react-toastify';
import { PostAPI } from '../../../ApiServices/ApiServices'; // adjust path as needed

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 👈 used to get email passed from previous page
  const [otp, setOtp] = useState("");

  // ✅ Get email from previous page (you should pass it via navigate state)
  const email = location?.state?.email || "mohammedshafeek077@gmail.com";

  const handleChange = (value) => {
    setOtp(value);
    console.log("Entered OTP:", value);
  };

  const verifyCode = async () => {
    if (!otp || otp.length < 4) {
      toast.error("Please enter the full 4-digit code");
      return;
    }

    const url = "/auth/doctor/verify-otp";
    const data = { email, otp_code: otp };

    try {
      await PostAPI({ url, data }, async (res) => {
        if (res?.success && res?.statusCode === 200) {
          toast.success(res?.message || "OTP verified successfully");

          // ✅ Navigate to new password page, carrying email forward
          navigate("/newpassword", { state: { email } });
        } else {
          toast.error(res?.message || "Invalid OTP. Please try again.");
        }
      });
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="login-form container">
      <div className="right-content">
        <h4 className="form-head color-txt">Verify Email</h4>
        <p className="wel-content">
          Please enter the password reset code below <br />
          that was sent to <span className="color-txt">{email}</span>
        </p>
      </div>

      <div className="form-box">
        <p>Enter Verification Code</p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <OTPInput
            value={otp}
            onChange={handleChange}
            numInputs={4}
            separator={<span style={{ margin: "0 8px" }}>-</span>}
            renderInput={(props) => <input {...props} />}
            inputStyle={{
              width: "40px",
              height: "40px",
              margin: "10px 5px",
              fontSize: "18px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              textAlign: "center",
            }}
            focusStyle={{
              border: "1px solid #007BFF",
              outline: "none",
            }}
          />
        </div>

        <Button variant="primary" onClick={verifyCode} className="mt-3">
          Verify
        </Button>
      </div>
    </div>
  );
};

export default VerifyEmail;
